module.exports = __webpack_public_path__ + "static/media/rsz_rsk.ca69b3c7.webp";